<template>
  <div class="wrapper">
    <h3 class="title"><slot name="title" /></h3>
    <p class="subtitle"><slot name="subtitle" /></p>
  </div>
</template>

<script>
export default { name: "SummaryItem" };
</script>

<style scoped lang="less">
.wrapper {
  display: flex;
  flex-direction: column;
  color: #a5d8ff;
  gap: 5px;
  .title {
    font-family: Montserrat;
    font-weight: 700;
    font-style: Bold;
    font-size: 64px;
    line-height: 1;
    margin: 0;
    @media (max-width: 1439px) {
      font-family: Montserrat;
      font-weight: 700;
      font-size: 48px;
    }
  }

  .subtitle {
    font-family: Montserrat;
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    line-height: 1;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    @media (max-width: 1439px) {
      font-weight: 600;
      font-size: 16px;
    }
  }
}
</style>
